module.exports = __webpack_public_path__ + "img/logo.0030f87d.png";